import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { paletteSuccessMain } from '@/theme/designTokens'
import {
  CAMPAIGN_LANDING_FILTER_OPTIONS,
  type CampaignLandingFilter,
} from '../lib/campaign-landing-display'

type Props = Readonly<{
  value: CampaignLandingFilter
  onChange: (value: CampaignLandingFilter) => void
}>

const PILL_TEAL_HOVER = '#0b8560'

export function CampaignStatusFilter({ value, onChange }: Props) {
  return (
    <Box
      data-testid="campaign-list-status-filter"
      role="tablist"
      aria-label="Filter campaigns by status"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
      }}
    >
      {CAMPAIGN_LANDING_FILTER_OPTIONS.map((option) => {
        const selected = value === option.value
        return (
          <Button
            key={option.value}
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(option.value)}
            data-testid={`campaign-list-status-filter-${option.value}`}
            sx={{
              borderRadius: '999px',
              height: 36,
              px: '16px',
              py: '8px',
              minWidth: 'auto',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '20px',
              letterSpacing: '-0.1504px',
              border: '1px solid',
              borderColor: selected ? paletteSuccessMain : '#e2e8f0',
              bgcolor: selected ? paletteSuccessMain : '#fff',
              color: selected ? '#fff' : '#64748b',
              boxShadow: 'none',
              '&:hover': {
                bgcolor: selected ? PILL_TEAL_HOVER : '#f8fafc',
                borderColor: selected ? PILL_TEAL_HOVER : '#cbd5e1',
                boxShadow: 'none',
              },
            }}
          >
            {option.label}
          </Button>
        )
      })}
    </Box>
  )
}
